import {CLStore} from 'common/src/redux/store';
import initializeCreativesAgents from './initializeCreativesAgents';
import initializeCreativesUiContexts from './initializeCreativesUiContexts';

function initializeCreatives(store: CLStore) {
  initializeCreativesUiContexts(store);
  initializeCreativesAgents(store);
}

export default initializeCreatives;
